import { Link } from 'react-router-dom';
import '../style/projects.scss';
import Loading from "../components/Loading";

import { useState, useEffect } from 'react';
import sanityClient from '../../client';
import NavAr from "./NavAr";
import FooterAr from "./FooterAr";

function PropertiesAr({ lang }) {
  const [properties, setProperties] = useState(null);
  const [loading, setLoading] = useState(true);
  const arabic = { direction: "rtl" };
  const [page, setPage] = useState(1);
  const [propCount, setPropCount] = useState(0);
  

  useEffect(() => {
    sanityClient.fetch(`count(*[_type=="properties"])`).then((data) => {
      setPropCount(data);
    });
    document.title = "العقارات - CompanyName";
    document.querySelector("html").lang = "ar";

  }, []);

  useEffect(() => {
    
    let start = (page - 1) * 12;
    let end = start + 12;
    sanityClient
      .fetch(
        `*[_type=="properties"] | order(_createdAt desc){
          "name": name.ar,
          "slug": Slug.current,
          "imgUrl" : images[0].asset->url,
          availability
        }[${start}...${end}]`
      )
      .then((data) => {
        setProperties(data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [lang, page]);

  if (loading) {
    return <Loading />;
  }

  const pageTotal = Math.ceil(propCount / 12);
  const items = [];
  if (pageTotal !== 1) {
    for (let i = 1; i <= pageTotal; i++) {
      items.push(
        <span
          key={i}
          onClick={() => {
            setPage(i);
            window.scrollTo(0, 0);
          }}
        >
          {i}
        </span>
      );
    }
  }
  return (
    <>
     <NavAr url="/properties" />
    <div className="projects" style={arabic}>
      <header>
        <h1>العقارات</h1>
      </header>
      <div className="all">
        {properties &&
          properties.map(({ name, slug, imgUrl, availability }) => {
            return (
              <Property
                img={imgUrl}
                name={name}
                key={slug}
                slug={slug}
                available={availability}
                
              />
            );
          })}
      </div>
      <div className="pagination">{items}</div>
    </div>
    <FooterAr />
    </>
  );
}

function Property({ img, name, slug, available }) {
  return (
    <div className="project">
      <Link to={'/ar/properties/' + slug}>
        <img src={img} alt={name} />

        <h3>
          {name} -{' '}
          {/* {language === 'en' && <span>{available ? 'for sale' : 'sold'}</span>}{' '} */}
          {<span>{available ? 'بيعة' : 'للبيع'}</span>}
        </h3>
      </Link>
    </div>
  );
}

export default PropertiesAr;
